export const formatFetchUrl = (path: string, param: any) => {
  const reg = new RegExp(/\{\{(.+?)\}\}/g);
  return path.replace(reg, (str: string) => {
    const key = str.replace(/\{\{/g, '').replace(/\}\}/g, '');
    return param[key] || '';
  });
};

/**
 * 解析API模板URL，拆分基本URL(不含最后的斜杠)和变量部分
 * @param urlTemplate API模板URL
 * @returns 包含基本URL和变量名的数组
 */
export function parseApiTemplate(urlTemplate: string): string[] {
  const regex = /^(.*?)\/{{([A-Z_]+)}}$/;
  const match = urlTemplate.match(regex);

  if (match) {
    return [match[1], match[2]];
  }

  // 如果没有匹配成功，返回原始字符串，并去掉可能的最后一个斜杠
  return [urlTemplate.replace(/\/$/, '')];
}
